export const FORM_FIELDS_NAME = {
    NEW_PASSWORD: {
        name: 'newPassword',
        label: 'New Password',
        type: 'password',
        placeholder: 'Enter new password',
        rules: {
          required: 'password is required',
        }
      },
    CONFIRM_PASSWORD:{
        name: 'confirmPassword',
        label: 'Confirm Password',
        type: 'password',
        placeholder: 'Enter confirm password',
        rules: {
          required: 'password is required',
        }
    }


}